// redux/Companies/reducer.js

import {
    FETCH_COMPANIES_SUCCESS,
    FETCH_COMPANIES_FAILURE,
    FETCH_COMPANY_SUCCESS,
    FETCH_COMPANY_FAILURE, // Corrected the duplicate action type
    CREATE_COMPANY_SUCCESS,
    CREATE_COMPANY_FAILURE,
    UPDATE_COMPANY_SUCCESS,
    UPDATE_COMPANY_FAILURE,
    DELETE_COMPANY_SUCCESS,
    DELETE_COMPANY_FAILURE,
  } from './types';
  
  const initialState = {
    companies: [],
    company: null,
    error: '',
  };
  
  export function companiesReducer(state = initialState, action) {
    switch (action.type) {
      case FETCH_COMPANIES_SUCCESS:
        return {
          ...state,
          companies: action.payload,
          error: '',
        };
      case FETCH_COMPANIES_FAILURE:
        return {
          ...state,
          error: action.payload,
        };
      case FETCH_COMPANY_SUCCESS:
        return {
          ...state,
          company: action.payload,
          error: '',
        };
      case FETCH_COMPANY_FAILURE:
        return {
          ...state,
          error: action.payload,
        };
      case CREATE_COMPANY_SUCCESS:
        return {
          ...state,
          companies: [...state.companies, action.payload],
          error: '',
        };
      case CREATE_COMPANY_FAILURE:
        return {
          ...state,
          error: action.payload,
        };
      case UPDATE_COMPANY_SUCCESS:
        return {
          ...state,
          companies: state.companies.map((company) =>
            company._id === action.payload._id ? action.payload : company
          ),
          error: '',
        };
      case UPDATE_COMPANY_FAILURE:
        return {
          ...state,
          error: action.payload,
        };
      case DELETE_COMPANY_SUCCESS:
        return {
          ...state,
          companies: state.companies.filter((company) => company._id !== action.payload),
          error: '',
        };
      case DELETE_COMPANY_FAILURE:
        return {
          ...state,
          error: action.payload,
        };
      default:
        return state;
    }
  }
  